module.exports = __webpack_public_path__ + "img/swiper_3.0_1_1.9f8778d5.webp";